export const DEFAULT_LOCALE = 'de-DE';
